export default __webpack_public_path__ + "static/media/6658bde3176aa6ff716975c2f32c1ad5.jpg";